//
//
//
//
//
//
//
//
//

export default {
    name: "other1",
    created() {
        document.title = this.$t('other.other1')[0]
    }
}



// WEBPACK FOOTER //
// ./src/page/other/other1.vue